import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkRendererComponent } from './link-renderer.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ LinkRendererComponent ],
  exports: [ LinkRendererComponent ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class LinkRendererModule { }
